import React from 'react'
import Products from '../../Products/Products'
import useFetch from '../../../hooks/useFetch'

function RelatedProduct({productId, categoryId}: any) {
  const {data} = useFetch(`/api/products?populate=*&filters[id][$ne]=${productId}&filters[categories][id]=${categoryId}&pagination[start]=0&pagination[limit]=4`)
  return (
    <div className='related-prod'>
      <Products products={data} titleText="Related Products"/>
    </div>
  )
}

export default RelatedProduct
